export * from './IndustryIcon'
